import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import * as SupervisorActions from './supervisor.actions';
import { DEFAULT_SUPERVISORS } from './supervisor.constants';

@Injectable()
export class SupervisorEffects {
  private actions$ = inject(Actions);

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SupervisorActions.loadSupervisors),
      map(() => SupervisorActions.loadSupervisorsSuccess({ supervisors: DEFAULT_SUPERVISORS })),
      catchError((error) =>
        of(
          SupervisorActions.loadSupervisorsFailure({
            error: error?.message || 'Failed to load supervisors',
          })
        )
      )
    )
  );
}
